import React from 'react';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import './KPITooltip.css';

const KPITooltip = ({ index, content, title, disabled }) => (
  <div className="info-icon-container">
    <Tippy
      content={
        <div className="kpi-tooltip-content">
          {title && (
            <div className="kpi-tooltip-title">
              {title}
            </div>
          )}
          <div className="kpi-tooltip-description">{content}</div>
        </div>
      }
      placement="bottom"
      arrow={true}
      trigger="mouseenter focus click touchstart" // Handle touch events
      hideOnClick={true}
      theme="custom" // Use custom theme defined in CSS
      disabled={disabled} // Disable the tooltip when swiping
      className="kpi-tippy-tooltip"
    >
      <div className="">
        {/* Icon for displaying tooltip */}
        <svg className="info-icon" viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="10" strokeWidth="1.5" />
          <text x="12" y="16" textAnchor="middle" fontSize="12" fill="currentColor" className="tooltipI">i</text>
        </svg>
      </div>
    </Tippy>
  </div>
);

export default KPITooltip;
